import { useTranslation } from "react-i18next";
import { useAppTheme } from "../../../../../useAppTheme";
import InfoAlert from "../../../../InfoAlert";

type Props = {
	visible: boolean;
	onDismiss: () => void;
};

export const TimeOverrunBanner = ({ visible, onDismiss }: Props) => {
	const theme = useAppTheme();
	const { t } = useTranslation();

	if (!visible) {
		return null;
	}

	return (
		<InfoAlert
			text={t("session.timeOverrunBanner.message")}
			icon="clock-alert-outline"
			backgroundColor={theme.colors.errorContainer}
			contentColor={theme.colors.onErrorContainer}
			buttonProps={{
				cta: t("common.gotIt"),
				onPress: onDismiss,
			}}
		/>
	);
};

export default TimeOverrunBanner;
